import React from 'react';

import { useSelector } from 'react-redux';

import _get from 'lodash/get';

import { ErrorBoundary } from '@bonnet/next/error-boundary';

import { useFeatures } from '@atc/features';

import { kbbVRSDataDuck, queryDuck } from '@/ducks';

import {
    bapActiveModelDuck,
    bapModelInfoDuck,
} from '@/ducks/bap';

import OwnerDetailsSnapshot from '@/components/OwnerDetailsSnapshot/index.js';
import PrivateOwnerDetails from '@/components/PrivateOwnerDetails/index.js';

import getBapTrimId from './utilities/getBapTrimId';

export function BuildAndPriceOwnerDetailsSnapshotContainer({
    phoneClickHandler,
    listing = {},
}) {
    const {
        disable_dealer_rating: [isDealerRatingDisabled],
    } = useFeatures(['disable_dealer_rating']);

    const query = useSelector(queryDuck.selectors.getDuckState);
    const makeCodeList = query?.makeCode || query?.makeCodeList;
    const makeCode = !Array.isArray(makeCodeList) && makeCodeList;
    const modelCode = useSelector(bapActiveModelDuck.selectors.getDuckState) || '';

    const kbbVRSData = useSelector(kbbVRSDataDuck.selectors.getData) || {};
    const selectedTrim = useSelector(bapModelInfoDuck.selectors.getDuckState);
    const trimsData = Object.values(_get(kbbVRSData, [makeCode, modelCode], []));
    const trimValue = trimsData.find((item) => getBapTrimId(item) === selectedTrim);

    const {
        id: listingId,
        owner = {},
    } = listing;

    const listingOwner = {
        ...owner,
        chat: null,
        rating: !isDealerRatingDisabled ? owner?.rating : undefined,
    };

    const ownerDetails = {
        phoneClickHandler,
        listing: {
            ...listing,
            owner: listingOwner,
        },
    };

    const dealerSnapshot = (
        <ErrorBoundary>
            <OwnerDetailsSnapshot
                {...ownerDetails}
                showAddress
                selectedVrsData={kbbVRSData?.[makeCode]?.[modelCode]?.[selectedTrim]}
                trimSelected={trimValue?.trimName?.toLowerCase()}
            />
        </ErrorBoundary>
    );

    const privateSnapshot = (
        <PrivateOwnerDetails
            listingId={listingId}
            owner={owner}
            phoneClickHandler={phoneClickHandler}
        />
    );

    return (
        <div className="bg-info-100 padding-4 margin-bottom-5 tip border-blue">
            {owner.privateSeller ? privateSnapshot : dealerSnapshot}
        </div>
    );
}

export default BuildAndPriceOwnerDetailsSnapshotContainer;
